import React from 'react'
import { ActiveSpeakerSignal2xWide } from '../ActiveSpeakerSignal/ActiveSpeakerSignal2xWide'
import { useVolume } from '../../InPersonMeetingProvider.shared'

type MicVolumeLevelProps = {
  isRecording: boolean
}

export const MicVolumeLevel = ({ isRecording = false }: MicVolumeLevelProps) => {
  const { volume } = useVolume()
  return (
    <div className='mic-volume-level-card'>
      <div className='d-flex flex-row align-content-center align-items-center justify-content-center'>
        <ActiveSpeakerSignal2xWide isSpeaking={volume === 1 && isRecording} className='mic-level-animation' width={600} height={100} />
      </div>
    </div>
  )
}
